// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h4[data-v-a88d5e58]{font-size:1.15rem;margin:.7666666667rem 0 .46rem 0}.row[data-v-a88d5e58]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
